import { Helmet } from "react-helmet";
import React from "react";
import "../styles/AboutPage.scss";
import { Box } from "@mui/material";

const AboutPage: React.FC = () => (
  <>
    <Helmet>
      <title>About | Rate My Cribs</title>
      <meta
        name="description"
        content="Learn about Rate My Cribs, our mission to empower renters, and how we help you make better decisions with honest reviews and real tenant feedback."
      />
      <meta
        name="keywords"
        content="about rate my cribs, rental reviews, tenant feedback, mission, apartment reviews, honest reviews"
      />
      <link rel="canonical" href="https://ratemycribs.com/about" />
      <meta property="og:title" content="About | Rate My Cribs" />
      <meta
        property="og:description"
        content="Learn about Rate My Cribs, our mission to empower renters, and how we help you make better decisions with honest reviews and real tenant feedback."
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://ratemycribs.com/about" />
      <meta
        property="og:image"
        content="https://ratemycribs.com/og-image.png"
      />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="About | Rate My Cribs" />
      <meta
        name="twitter:description"
        content="Learn about Rate My Cribs, our mission to empower renters, and how we help you make better decisions with honest reviews and real tenant feedback."
      />
      <meta
        name="twitter:image"
        content="https://ratemycribs.com/og-image.png"
      />
    </Helmet>
    <Box
      component="main"
      id="main-content"
      tabIndex={-1}
      sx={{
        flex: 1,
        width: "100%",
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        padding: "1.7rem 0 1.7rem 0",
      }}
    >
      <Box
        sx={{
          background: "#fff",
          borderRadius: 2.25,
          boxShadow: "0 2px 16px rgba(0,0,0,0.08)",
          p: "1.5rem 2.5rem",
          maxWidth: 600,
          mx: "auto",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          animation: "slideUp 0.55s ease-out both",
          "@media (prefers-reduced-motion: reduce)": { animation: "none" },
          "@media (prefers-reduced-motion: no-preference)": {
            transition: "box-shadow 0.35s ease, transform 0.35s ease",
            "&:hover": {
              boxShadow: "0 12px 36px rgba(15,23,42,0.1)",
              transform: "translateY(-2px)",
            },
          },
        }}
      >
        <h1
          className="no-wrap-title"
          style={{
            color: "#1d4ed8",
            fontWeight: 800,
            marginBottom: 18,
            fontSize: 32,
            letterSpacing: 0.2,
          }}
        >
          About Rate My Cribs
        </h1>
        <p
          style={{
            fontSize: 18,
            color: "black",
            textAlign: "center",
            marginBottom: 24,
            lineHeight: 1.6,
          }}
        >
          <b>Rate My Cribs</b> is a platform for sharing and discovering honest
          reviews of rental properties. Our mission is to empower renters with
          transparent information and help everyone find their perfect home.
        </p>
        <div
          style={{
            background: "#fffbe6",
            borderRadius: 10,
            padding: "1rem 1.5rem",
            marginBottom: 20,
            width: "100%",
            color: "#b8860b",
            fontWeight: 500,
            fontSize: 16,
            textAlign: "center",
            boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
          }}
        >
          🚧 <b>Work in Progress:</b> This site is actively being improved.
          Feedback and suggestions are welcome—please use the contact link
          below!
        </div>
        <div
          style={{
            background: "#f5f7fa",
            borderRadius: 14,
            boxShadow: "0 1px 6px rgba(0,0,0,0.04)",
            padding: "1.5rem 1.5rem 1.2rem 1.5rem",
            width: "100%",
            marginBottom: 24,
          }}
        >
          <h2
            style={{
              color: "#1d4ed8",
              fontWeight: 700,
              fontSize: 22,
              textAlign: "center",
              marginTop: 0,
              marginBottom: "8px",
            }}
          >
            Why Rate My Cribs?
          </h2>
          <ul
            style={{
              textAlign: "left",
              fontSize: 17,
              color: "#444",
              margin: "0 0 0 1.2rem",
              lineHeight: 1.7,
            }}
          >
            <li>Share your experiences with others</li>
            <li>Read real reviews from real tenants</li>
            <li>Make informed decisions about your next home</li>
          </ul>
        </div>
        <div
          style={{
            fontSize: 20,
            marginBottom: "8px",
            marginTop: 0,
          }}
        >
          <h2
            style={{
              color: "#1d4ed8",
              fontWeight: 700,
              fontSize: 22,
              textAlign: "center",
              marginTop: 0,
              marginBottom: "8px",
            }}
          >
            Contact
          </h2>
          <p style={{ fontSize: 16, color: "#333", margin: 0 }}>
            Email:{" "}
            <a
              href="mailto:info.ratemycribs@gmail.com"
              style={{ color: "#1d4ed8", textDecoration: "underline" }}
            >
              info.ratemycribs@gmail.com
            </a>
          </p>
        </div>
      </Box>
    </Box>
  </>
);

export default AboutPage;
